import * as yup from "yup";

const BANK_PERMISSION_GRANTED = "You have not given us permission";
const BANK_BSB_REQUIRED = "The BSB number is required";
const BANK_ACC_NUMBER_REQUIRED = "The bank account number is required";
const BANK_ACC_NAME_REQUIRED = "The bank account name required";
const OPTION_SELECT = "Please select one option";

const bankPermissionQuestionValidation = (value) => {
  if (typeof value === "undefined") return;
  if (value === "no") {
    return false;
  } else {
    return true;
  }
};

export function schemaPaymentDetails() {
  return yup
    .object()
    .shape({
      [`bankPaymentPermissionGranted`]: yup
        .string()
        .when("$isPaymentMethodTypeBankAccount", {
          is: true,
          then: yup
            .string()
            .oneOf(["yes", "no"])
            .when(["bankPaymentPermissionGranted"], {
              is: (value) => value === "yes" || value === "no",
              then: yup
                .string()
                .test("bankPermissionQuestion", "", (value) => value !== "no"),
            })
            .required(OPTION_SELECT),
          otherwise: yup.string().nullable().notRequired(),
        }),
      [`bankAccountNumber`]: yup
        .string()
        .when("$isPaymentMethodTypeBankAccount", {
          is: true,
          then: yup.string().required(BANK_ACC_NUMBER_REQUIRED),
          otherwise: yup.string().nullable().notRequired(),
        }),
      [`bankAccountName`]: yup
        .string()
        .trim()
        .when("$isPaymentMethodTypeBankAccount", {
          is: true,
          then: yup.string().required(BANK_ACC_NAME_REQUIRED),
          otherwise: yup.string().nullable().notRequired(),
        }),
    })
    .required();
}
